import _get from "lodash/get";
import _round from "lodash/round";

/**
 * Checks if the difference between first and second parameters are within third
 * @private
 * @param {number} val1 first value
 * @param {number} val2 second value
 * @param {number} precision how percise should we be?
 * @returns {boolean} are the values close enough?
 */
function closeTo(val1, val2, precision) {
  return val1 !== undefined && val2 !== undefined && Math.abs(_round(val1 - val2, precision)) <= Math.pow(10, -precision);
}
/**
 * Runs a calculation until it converges on a "close enough value".
 * @module lib/limit-calculation
 * @param {number} initialValue the value to start the calcuation
 * @param {function} comparator a function that accepts the old/initial value and returns a new value
 * @param {number} [limit=20] maximum number of times to attempt the calculation
 * @param {number} [precision=3] how far apart is the delta or tolerance, defaults to 3 decimal places
 * @returns {number} the converged value
 */


export default (function (initialValue, comparator, path) {
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
  var precision = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 3;
  var oldValue;
  var newValue = initialValue;

  for (var i = 0; i < limit; i += 1) {
    oldValue = newValue;
    newValue = comparator(oldValue);

    if (closeTo(_get(newValue, path), _get(oldValue, path), precision)) {
      return newValue;
    }
  }

  return newValue;
});